'use client';

export const decodedHtml = (html: string): string => {
  const txtElement = document.createElement('textarea');
  txtElement.innerHTML = html;

  return txtElement.value;
};
